export default [
    {
        name: 'building',
        hideLabel: true,
        component: {
            type: 'v-autocomplete',
            props: {
                label: 'Building',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'wing',
        hideLabel: true,
        component: {
            type: 'v-autocomplete',
            props: {
                label: 'Wing',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'floor',
        hideLabel: true,
        component: {
            type: 'v-autocomplete',
            props: {
                label: 'Floor',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'room',
        hideLabel: true,
        component: {
            type: 'v-autocomplete',
            props: {
                label: 'Room Number',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'vmsTags.name',
        hideLabel: true,
        component: {
            type: 'v-autocomplete',
            props: {
                label: 'Tags',
                dense: true,
                clearable: true,
                smallChips: true,
                deletableChips: true,
                multiple: true,
                hideSelected: true,
                itemText: 'name',
                itemValue: 'name'
            }
        }
    },
    {
        name: 'serviceAccount.devices.healthCheckStatus',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Health',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'visibility',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Visibility',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'occupiedStatus',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Occupied',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'hasDevices',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Has devices',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'serviceAccount.notVenueChannelMapId',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Has default channel map overridden',
                dense: true,
                clearable: true
            }
        }
    }
];
